import { defineStore } from 'pinia'
import { fetchItems, suggestReplenishment } from '@/api/replenishmentMethods'
import useCrudStore from '@/hooks/useCrudStore'
import { ISuggesReplenishmentData } from '@/interfaces/replenishmentMethods'

export const useReplenishmentMethodsStore = defineStore(
  'replenishmentMethods',
  () => {
    const { items, currentItems, listLoading, FetchItems } = useCrudStore({
      fetchItems
    })

    const SuggestReplenishment = (payload: ISuggestReplenishmentData) => {
      return suggestReplenishment(payload)
    }

    return {
      items,
      currentItems,
      listLoading,
      FetchItems,
      SuggestReplenishment
    }
  }
)
